/**
 * @desc 出库情况分页查询
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.demandOrder.exWarehouse.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/exWarehouse/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
